nz-header{background-color:#fff!important}.ant-table-pagination,.ant-table-wrapper{background-color:#fff!important}::ng-deep .ant-table-small{border:1px solid #f0f0f0!important}
/*# sourceMappingURL=reusable-table-expand.component-AZVFYKJO.css.map */
